import AOS from "aos";
import "aos/dist/aos.css";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/css/animation.scss";
import Chat from "./components/Chat/Chat";
import MainLayout from "./layouts/MainLayout";
import PrivatePage from "./layouts/PrivatePage";
import ScrollToTop from "./pages/ScrollToTop/ScrollToTop";
import routers from "./routers/router";
import ReactPixel from "react-facebook-pixel";
import { useSelector } from "react-redux";

function App() {
  const token = Cookies.get("token");
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    if (token) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [token]);

  useEffect(() => {
    AOS.init();
    AOS.init({
      duration: 1000,
    });

    const options = {
      autoConfig: true,
      debug: false,
    };

    ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID, options);
    ReactPixel.pageView();
  }, []);

  return (
    <React.Fragment>
      <BrowserRouter>
        <ScrollToTop />

        <Chat />

        <Routes>
          {routers.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.private === true ? (
                  route.isChild ? (
                    <PrivatePage>
                      <MainLayout>{route.element}</MainLayout>
                    </PrivatePage>
                  ) : (
                    <PrivatePage>{route.element}</PrivatePage>
                  )
                ) : (
                  <MainLayout>{route.element}</MainLayout>
                )
              }
            />
          ))}
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
